import {HttpClient} from "../../service/httpClient/HttpClient";
import {uploadFile} from "../../service/uploaderService/UploaderService";

export class VideoService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getVideosList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-video-clips`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getVideoDetail(clipId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-video-clips/${clipId}`
            ).then(resolve).catch(reject)
        })
    }

    deleteVideo(clipId, title, writerName, shortDescription, description, aparatLink, thumbnailId, enabled) {
        return new Promise((resolve, reject) => {
            this.doUpdateClipInfo(clipId, description, shortDescription, title, thumbnailId, writerName, aparatLink, enabled, resolve, reject);
        })
    }

    doUpdateClipInfo(clipId, description, shortDescription, title, thumbnailId, writerName, aparatLink, enabled, resolve, reject) {
        this.httpClient.put(
            `site-video-clips/${clipId}`,
            {
                "description": description,
                "shortDescription": shortDescription,
                "title": title,
                "thumbnailId": thumbnailId,
                "authorInformation": writerName,
                "aparatScript": aparatLink,
                "enabled": enabled
            }
        ).then(resolve).catch(reject)
    }

    addNewClip(photoFile, title, writerName, aparatLink, shortDescription, description) {
        return new Promise((resolve, reject) => {
            uploadFile(
                photoFile,
                "thumbnails/compressing/VERY_LOW"
            ).then(response => {
                this.httpClient.post(
                    "site-video-clips",
                    {
                        "title": title,
                        "thumbnailId": response.id,
                        "description": description,
                        "shortDescription": shortDescription,
                        "authorInformation": writerName,
                        "aparatScript": aparatLink,
                        "enabled": true
                    }
                ).then(resolve).catch(reject)
            }).catch(reject)
        })
    }

    updateClipInfo(clipId, title, writerName, aparatLink, photoFile, photoId, shortDescription, description, enabled) {
        return new Promise((resolve, reject) => {
            if (photoFile) {
                uploadFile(
                    photoFile,
                    `thumbnails/compressing/VERY_LOW`
                ).then(response => {
                    this.doUpdateClipInfo(
                        clipId,
                        description,
                        shortDescription,
                        title,
                        response.id,
                        writerName,
                        aparatLink,
                        enabled,
                        resolve,
                        reject
                    )
                }).catch(reject)
            } else {
                this.doUpdateClipInfo(
                    clipId,
                    description,
                    shortDescription,
                    title,
                    photoId,
                    writerName,
                    aparatLink,
                    enabled,
                    resolve,
                    reject
                )
            }
        })
    }
}